import { BetSlipErrorType } from '@models/shared/betSlip/betSlipEnums';
import { BonusErrorType } from '@superbet-group/betting.lib.validation';

export default interface IBetSlipError {
    isSelectionAddable: boolean;
    type: BetSlipErrorType;
    params?: any;
    shouldRemove?: boolean;
    isInfo?: boolean;
}

export type IBonusBetSlipError = Omit<IBetSlipError, 'type'> & { type: BonusErrorType };

export class BetSlipErrorFactory {
    public static createErrorsInSelections(): IBetSlipError {
        return {
            isSelectionAddable: true,
            type: BetSlipErrorType.errorsInSelection,
        };
    }

    public static createChooseTicketNegotiationError(): IBetSlipError {
        return {
            isSelectionAddable: false,
            type: BetSlipErrorType.chooseTicketNegotiation,
        };
    }

    public static createNoSelectedSystemCombinationError(): IBetSlipError {
        return {
            isSelectionAddable: true,
            type: BetSlipErrorType.noSelectedSystemCombination,
        };
    }

    public static createSelectionIsUnavailable({ betStart, betEnd }: { betStart: Date; betEnd: Date }): IBetSlipError {
        return {
            isSelectionAddable: false,
            type: BetSlipErrorType.selectionIsUnavailable,
            params: {
                betStart,
                betEnd,
            },
            shouldRemove: true,
        };
    }

    public static createEventCantPlaceBets(): IBetSlipError {
        return {
            isSelectionAddable: false,
            type: BetSlipErrorType.eventCantPlaceBets,
            shouldRemove: true,
        };
    }

    public static createMinSystemToPlayError(
        minTotal: number,
        fromNumber: number,
    ): IBetSlipError {
        return {
            isSelectionAddable: false,
            type: BetSlipErrorType.minSystemToPlay,
            params: {
                fromNumber,
                minNumber: minTotal,
            },
        };
    }

    public static createFreeBetSystemError(): IBetSlipError {
        return {
            isSelectionAddable: true,
            type: BetSlipErrorType.freeBetSystem,
        };
    }

    public static createMinEventsSystemError(minEvents: number): IBetSlipError {
        return {
            isSelectionAddable: true,
            type: BetSlipErrorType.minEventsSystem,
            params: {
                minEvents,
            },
        };
    }

    public static createMinEventOddInSystemError(minOdd: number): IBetSlipError {
        return {
            isSelectionAddable: true,
            type: BetSlipErrorType.minSystemEventOdd,
            params: {
                minOdd,
            },
        };
    }

    public static createMinSystemOddError(minOdd: number): IBetSlipError {
        return {
            isSelectionAddable: true,
            type: BetSlipErrorType.minSystemOdd,
            params: {
                minOdd,
            },
        };
    }

    public static createUtilizationEventError(eventName: string): IBetSlipError {
        return {
            isSelectionAddable: true,
            type: BetSlipErrorType.utilizationEvent,
            params: {
                eventName,
            },
        };
    }

    public static createMarketEventError(marketName?: string): IBetSlipError {
        return {
            isSelectionAddable: true,
            type: BetSlipErrorType.marketEvent,
            params: {
                marketName,
            },
        };
    }

    public static createCantUseFreeBetBonus(): IBetSlipError {
        return {
            isSelectionAddable: true,
            type: BetSlipErrorType.cantUseFreeBetBonus,
        };
    }

    public static createMinEventOddError(eventName: string, minOdd: number): IBetSlipError {
        return {
            isSelectionAddable: true,
            type: BetSlipErrorType.minEventOdd,
            params: {
                eventName,
                minOdd,
            },
        };
    }
}
